import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Detail from './views/Detail.vue';
import Login from './views/Login.vue'
import AccountList from './views/AccountList.vue';
import ArchivedAccounts from './views/ArchivedAccounts.vue';
import NewAccount from './views/NewAccount.vue';
import Reporting from './views/Reporting.vue';
import AccessDenied from './views/AccessDenied.vue';
import  store  from './store';

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {requiresAuth: true}
    },
    {
      path: '/detail/:id',
      name: 'detail',
      component: Detail,
      props: true,
      meta: {requiresAuth: true}
    },
    {
      path: '/accounts',
      name: 'accountList',
      component: AccountList,
      meta: {requiresAuth: true}
    },
    {
      path: '/new-account',
      name: 'newAccount',
      component: NewAccount,
      meta: {requiresAuth: true}
    },
    {
      path: '/reporting',
      name: 'reporting',
      component: Reporting,
      meta: {requiresAuth: true}
    },
    {
      path: '/archived-accounts',
      name: 'archivedAccounts',
      component: ArchivedAccounts,
      meta: {requiresAuth: true}
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/access-denied',
      name: 'accessDenied',
      component: AccessDenied
    }

  ]
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const user = store.getters.user;
    if (!user) {
      next({
        path: '/login',
        // query: { redirect: to.fullPath }
      })
    }  else {
      if(store.getters.denied){
        next({
          path: 'access-denied'
        })
      } else{

        next()
      }
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
